import { useSelector } from "react-redux";
import useT from "../../i18n/useT";
import { Download, Server } from "react-bootstrap-icons";

const Reports = () => {
    const t = useT();
    const role = useSelector((state) => state.user.role);
    const isStaff = role === "admin" || role === "moderator";
    const isAdmin = role === "admin";

    if (!isStaff) {
        return <div className="page-content-main-container"><h2 className="page-title">{t("reports.title")}</h2></div>;
    }

    const dl = (url) => window.open(url, "_blank");

    const items = [
        { key: "reports.transactions", url: "/api/reports/transactions/export" },
        { key: "reports.financial", url: "/api/reports/financial-summary/export" },
        { key: "reports.activity", url: "/api/reports/activity/export" },
        { key: "reports.vehicles", url: "/api/vehicles/export" },
        { key: "reports.containers", url: "/api/containers/export" },
        { key: "reports.bookings", url: "/api/booking/export" },
    ];

    return (
        <div className="page-content-main-container">
            <h2 className="page-title">{t("reports.title")}</h2>

            <h3 style={{ fontSize: "15px", margin: "6px 0 12px" }}>{t("reports.exports")}</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: "12px", maxWidth: "760px" }}>
                {items.map((it) => (
                    <div key={it.key} style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: "12px", padding: "16px", display: "flex", flexDirection: "column", gap: "12px" }}>
                        <span style={{ fontWeight: 600, fontSize: "14px" }}>{t(it.key)}</span>
                        <button className="btn btn-sm btn-primary" onClick={() => dl(it.url)}><Download /> {t("reports.download")}</button>
                    </div>
                ))}
            </div>

            {isAdmin && (
                <div style={{ marginTop: "28px", maxWidth: "520px" }}>
                    <h3 style={{ fontSize: "15px", margin: "6px 0 12px" }}>{t("reports.backup")}</h3>
                    <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: "12px", padding: "18px" }}>
                        <div style={{ fontSize: "13px", opacity: 0.7, marginBottom: "14px" }}>{t("reports.backupHint")}</div>
                        <button className="btn btn-outline-secondary" onClick={() => dl("/api/reports/backup")}><Server /> {t("reports.downloadBackup")}</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Reports;
